// import cls from 'classnames';
import { Button } from '@bfe/moly';
import { Arrowchevron2DownIcon } from '@bfe/moly-icons';
import { useFm } from '@web3/base-hooks';
// import { openLink } from '@web3/base-utils';
// import walletIcon from '@/assets/imgs/wallet.png';

// import styles from './style.scss';

interface ViewMoreProps {
  children?: React.ReactNode;
  noMore: boolean;
  loadMore: () => void;
}

export const ViewMore: React.FC<ViewMoreProps> = (props: ViewMoreProps) => {
  const fm = useFm();

  return (
    <div className="view-more-wrap">
      {props.children}
      {!props.noMore && (
        <div className="flex justify-center items-center mt-4">
          <Button
            className="h-12 gap-2 text-gray !border-0 !bg-transparent"
            onClick={props.loadMore}
          >
            {fm('viewMore')}
            <Arrowchevron2DownIcon />
          </Button>
        </div>
      )}
    </div>
  );
};
